import React from 'react';
import '../App.css';

function Header() {
    return (
        <div id="dinnerPartyHeader">
            <div id="headerContainer">
                <img
                    src="https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Header_1.gif"
                    alt="Spot illustration of guests talking"
                />
                <h1>
                    <span id="across">Across</span>
                    <br />
                    <span id="table">the Table</span>
                </h1>
                <img
                    src="https://assets.pewresearch.org/interactives/politics/2019/dinner-party/Header_2.gif"
                    alt="Spot illustration of guests talking"
                />
            </div>
            <p className="subhead">
                Would you share your views
                <br />
                of Donald Trump over dinner?
            </p>
            <div className="meta">
                <span className="byline">
                    By{' '}
                    <a
                        href="https://www.pewresearch.org/staff/amina-dunn/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Amina Dunn
                    </a>
                    ,{' '}
                    <a
                        href="https://www.pewresearch.org/staff/jocelyn-kiley/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Jocelyn Kiley
                    </a>
                    ,{' '}
                    <a
                        href="https://www.pewresearch.org/staff/alissa-scheller/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Alissa Scheller
                    </a>
                    ,{' '}
                    <a
                        href="https://www.pewresearch.org/staff/danielle-alberti/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Danielle Alberti
                    </a>{' '}
                    and{' '}
                    <a
                        href="https://www.pewresearch.org/staff/carroll-doherty/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        Carroll Doherty
                    </a>
                </span>
            </div>
        </div>
    );
}

export default Header;
